import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTravellerCreate(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M18 1C18.5523 1 19 1.44772 19 2V4H21C21.5523 4 22 4.44772 22 5C22 5.55228 21.5523 6 21 6H19V8C19 8.55228 18.5523 9 18 9C17.4477 9 17 8.55228 17 8V6H15C14.4477 6 14 5.55228 14 5C14 4.44771 14.4477 4 15 4H17V2C17 1.44772 17.4477 1 18 1Z"
        fill="currentColor"
      />
      <path
        d="M5 2H11C11.5523 2 12 2.44772 12 3C12 3.55228 11.5523 4 11 4H5V15.8647C6.67224 14.4199 10.0448 13.5 12 13.5C13.9552 13.5 17.3278 14.4199 19 15.8647V12C19 11.4477 19.4477 11 20 11C20.5523 11 21 11.4477 21 12V17C21 18.1046 20.1046 19 19 19H15.5L13.2 22.0667C12.6 22.8667 11.4 22.8667 10.8 22.0667L8.5 19H5C3.89543 19 3 18.1046 3 17V4C3 2.89543 3.89543 2 5 2Z"
        fill="currentColor"
      />
      <path
        d="M12 12C13.6543 12 15 10.6543 15 9C15 7.34571 13.6543 6 12 6C10.3457 6 9 7.34571 9 9C9 10.6543 10.3457 12 12 12Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
